module.exports = __webpack_public_path__ + "img/40.c17e8016.png";